export const availability = [
  { label: 'Até 2 horas', value: 2 },
  { label: 'Até 5 horas', value: 5 },
  { label: 'Até 10 horas', value: 10 },
  { label: 'Mais de 10 horas', value: 11 },
];
